/** @jsxImportSource @emotion/react */
import { styles } from './CareersHero.styles';
import { useTranslation } from 'react-i18next';

export default function CareersHero() {
  const { t } = useTranslation();
  return (
    <section css={styles.wrapper}>
      <div css={styles.top}>
        <span css={styles.label}>{t('career.label')}</span>
        <div css={styles.line} />
      </div>

      <div css={styles.content}>
        <h1 css={styles.title}>{t('career.title')}</h1>

        <h3 css={styles.text}>{t('career.tagline')}</h3>
      </div>
    </section>
  );
}
